import { render, staticRenderFns } from "./KrausInput.vue?vue&type=template&id=35f0fdee&lang=pug&"
import script from "./KrausInput.vue?vue&type=script&lang=js&"
export * from "./KrausInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports